import React from "react";
import { Pagination } from "@/components/ui";
import { CheckCircle } from "lucide-react";
import { useTelecallers } from "../hooks/useTelecallers";
import { useOfficeLocations } from "../hooks/useOfficeLocations";
import { CustomersTableView } from "./CustomersTableView";
import { CustomersKanban } from "./CustomersKanban";

export const AssignCustomersView = ({
  customers,
  onAssign,
  viewStyle,
  stages,
  page,
  totalPages,
  onPageChange,
  totalCustomers,
  unassignedCount,
  onEdit,
  onToggleDisable,
  onView,
  updateStatus,
  assignModalOpen,
  setAssignModalOpen,
}) => {
  const { filteredTelecallers: teamMembers } = useTelecallers("", true);
  const { locations: officeLocations } = useOfficeLocations();

  const getMemberName = (id) => {
    if (!id) return "Unassigned";
    if (typeof id === 'object') return id.name || "Unknown";
    if (!Array.isArray(teamMembers)) return "Unknown";
    const member = teamMembers.find(m => m._id === id);
    return member ? member.name : "Unknown";
  };

  const getfmtDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: '2-digit',
      hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="space-y-4">
      <div className="card rounded-none overflow-hidden border-orange-100 shadow-sm min-h-[400px]">
        {customers.length > 0 ? (
          viewStyle === 'kanban' ? (
            <CustomersKanban
              filtered={customers}
              onCustomerClick={onView}
              onEdit={onEdit}
              onToggleDisable={onToggleDisable}
              getMemberName={getMemberName}
              stages={stages}
              onStatusChange={updateStatus}
            />
          ) : (
            <CustomersTableView
              filtered={customers}
              onCustomerClick={onView}
              onEdit={onEdit}
              onToggleDisable={onToggleDisable}
              stages={stages}
              user={{ role: 'admin' }}
              telecallers={teamMembers}
              onAssignStaff={onAssign}
            />
          )
        ) : (
          <div className="p-20 text-center">
            <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4 border border-dashed border-slate-300">
              <CheckCircle size={32} className="text-emerald-500" />
            </div>
            <h4 className="font-bold text-slate-700">Perfect Distribution!</h4>
            <p className="text-sm text-slate-400 max-w-xs mx-auto mt-1">Every customer has been assigned. Your team is fully equipped!</p>
          </div>
        )}

        {totalPages > 1 && (
          <div className="border-t border-slate-100 mt-auto bg-white">
            <Pagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
          </div>
        )}
      </div>
    </div>
  );
};
